/**
 * Class representing audio library enums for actions, messages, and winner messages.
 * Provides a structured way to manage game-related constants.
 */
export default class AudioLib {
  /**
   * Static property containing action enums for the game.
   * Each action includes an `actionId` (used in switch cases) and a `description` for documentation purposes.
   */
  static actions = {
    ball: {
      actionId: 'ball',
      description: 'Handles ball-related actions',
    },
    message: {
      actionId: 'message',
      description: 'Handles general messages',
    },
    messagePersonnalise: {
      actionId: 'messagePersonnalise',
      description: 'Handles personalized messages',
    },
    winner: {
      actionId: 'winner',
      description: 'Handles winner announcements',
    },
    updateWinner: {
      actionId: 'updateWinner',
      description: 'Handles updates to winners',
    },
  };

  /**
   * Static property containing message enums for the game.
   * Each message includes:
   * - `messageId`: Identifier for the message.
   * - `description`: Explanation of the message's purpose.
   * - `message`: Default message text.
   * - `filePath`: Path to the audio file for this message.
   */
  static messages = {
    game_ended: {
      messageId: 'Message01',
      description: 'Attention le jeu est terminé',
      message: 'JEU TERMINÉ',
      filePath: '/public/Audio/F/Message01.mp3',
    },
    bingo_possibility: {
      messageId: 'Message02',
      description: 'Nous avons une possibilité de bingo',
      message: 'POSSIBILITÉ DE BINGO',
      filePath: '/Audio/F/Message02.mp3',
    },
    joker_ball: {
      messageId: 'Message03',
      description: 'Boule frimée en cours',
      message: 'BOULE FRIMÉE EN COURS',
      filePath: '/Audio/F/Message03.mp3',
    },
    update_card: {
      messageId: 'Message03a',
      description: 'Laisser quelques minutes pour mettre la carte a jour',
      message: 'Mettez votre carte a jour',
      filePath: '/Audio/F/Message03a.mp3',
    },
    game_starts_again: {
      messageId: 'Message04',
      description: 'Reprise du jeu',
      message: 'Reprise du Jeu',
      filePath: '/Audio/F/Message04.mp3',
    },
    half_and_half: {
      messageId: 'Message05',
      description: 'Moitié-moitié',
      message: '',
      filePath: '/Audio/F/Message05.mp3',
    },
    transcription_error: {
      messageId: 'Message06',
      description: 'Attention, Erreur de transcription',
      message: 'Attention, erreur de transcription',
      filePath: '/Audio/F/Message06.mp3',
    },
  };

  /**
   * Static property containing winner message enums for the game.
   * Each winner includes:
   * - `messageId`: Identifier for the winner message.
   * - `description`: Explanation of the winning condition.
   * - `message`: Default message text.
   */
  static winners = {
    winner01: {
      messageId: 'Winner01',
      description: 'Tour du Free gagné',
      message: 'TOUR DU FREE GAGNÉ',
    },
    winner02: {
      messageId: 'Winner02',
      description: 'Lettre X gagné',
      message: 'LETTRE X GAGNÉ',
    },
    winner03: {
      messageId: 'Winner03',
      description: 'Lettre E gagné',
      message: 'LETTRE E GAGNÉ',
    },
    winner04: {
      messageId: 'Winner04',
      description: 'Lettre U gagné',
      message: 'LETTRE U GAGNÉ',
    },
    winner05: {
      messageId: 'Winner05',
      description: 'Lettre F gagné',
      message: 'LETTRE F GAGNÉ',
    },
    winner06: {
      messageId: 'Winner06',
      description: 'Lettre C gagné',
      message: 'LETTRE C GAGNÉ',
    },
    winner07: {
      messageId: 'Winner07',
      description: 'Lettre P gagné',
      message: 'LETTRE P GAGNÉ',
    },
    winner08: {
      messageId: 'Winner08',
      description: 'Lettre W gagné',
      message: 'LETTRE W GAGNÉ',
    },
    winner09: {
      messageId: 'Winner09',
      description: 'Lettre H gagné',
      message: 'LETTRE H GAGNÉ',
    },
    winner10: {
      messageId: 'Winner10',
      description: 'Lettre N gagné',
      message: 'LETTRE N GAGNÉ',
    },
    winner11: {
      messageId: 'Winner11',
      description: 'Lettre L gagné',
      message: 'LETTRE L GAGNÉ',
    },
    winner12: {
      messageId: 'Winner12',
      description: '2 lignes gagné',
      message: '2 LIGNES GAGNÉ',
    },
    winner13: {
      messageId: 'Winner13',
      description: '3 lignes gagné',
      message: '3 LIGNES GAGNÉ',
    },
    winner14: {
      messageId: 'Winner14',
      description: 'Carte pleine gagné',
      message: 'CARTE PLEINE GAGNÉ',
    },
    winner15: {
      messageId: 'Winner15',
      description: 'Lettre Y gagné',
      message: 'LETTRE Y GAGNÉ',
    },
    winner16: {
      messageId: 'Winner16',
      description: 'Carte pleine gagné',
      message: 'CARTE PLEINE GAGNÉ',
    },
    winner17: {
      messageId: 'Winner17',
      description: 'Carte pleine gagné',
      message: 'CARTE PLEINE GAGNÉ',
    },
  };
};